import { BeaconBaseEvent } from '../../types/beacon-events';

const sendBeaconEvent = (event: BeaconBaseEvent) => (
  new Promise<boolean>(resolve => {
    try {
      window.lucid!.beacon.recordEvent(event);
      setTimeout(() => resolve(true), 250);
    } catch (error) {
      setTimeout(() => {
        try {
          window.lucid!.beacon.recordEvent(event);
          setTimeout(() => resolve(true), 250);
        } catch (e) {
          setTimeout(() => {
            try {
              window.lucid!.beacon.recordEvent(event);
              setTimeout(() => resolve(true), 250);
            } catch (e) {
              setTimeout(() => {
                try {
                  window.lucid!.beacon.recordEvent(event);
                  setTimeout(() => resolve(true), 250);
                } catch (e) {
                  setTimeout(() => {
                    try {
                      window.lucid!.beacon.recordEvent(event);
                      setTimeout(() => resolve(true), 250);
                    } catch (e) {
                      setTimeout(() => {
                        try {
                          window.lucid!.beacon.recordEvent(event);
                          setTimeout(() => resolve(true), 250);
                        } catch (error) {
                          console.info(
                            `Beacon event unable to fire: %c${event.name}. %c${error}`,
                            'color: red;',
                            'color: yellow;'
                          );
                          resolve(false);
                        }
                      }, 250);
                    }
                  }, 250);
                }
              }, 250);
            }
          }, 250);
        }
      }, 250);
    }
  })
);

export default sendBeaconEvent;
